import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";

import { Heading, PromoBannerV2, SpacingToken, Text } from "@livechat/design-system-react-components";

import backgroundImage from "assets/img/performance-table-promo-background.webp";
import Role from "constants/role";
import { trackEngagement } from "helpers/analytics";
import { getNextPlanHash } from "helpers/subscription-plans";
import { AgentsRoutes } from "routes/agents/constants";
import { SubscriptionRoutes } from "routes/subscription";
import { selectLoggedInAgentPermission } from "store/entities/agents";
import { selectCurrentSubscriptionPlan } from "store/entities/subscriptions";
import { withVar } from "themes/helpers";

export const PerformanceTablePromo: FC = () => {
  const history = useHistory();
  const agentRole = useSelector(selectLoggedInAgentPermission);
  const currentPlan = useSelector(selectCurrentSubscriptionPlan);
  const isAdmin = agentRole === Role.Owner;

  function handleUpgradeClick(): void {
    history.push(isAdmin ? `${SubscriptionRoutes.Plans}/${getNextPlanHash(currentPlan)}` : AgentsRoutes.Agents);
    trackEngagement("Agents performance table: upgrade CTA clicked", undefined, { agentRole });
  }
  return (
    <PromoBannerV2
      css={{ ".performance-table-promo": { paddingRight: 0 }, img: { maxWidth: "460px" } }}
      additionalContentClassName="performance-table-promo"
      primaryButton={{ label: "Upgrade now", handleClick: handleUpgradeClick }}
      additionalContent={<img src={backgroundImage} />}
    >
      <Heading size="lg" css={{ marginBottom: withVar(SpacingToken.Spacing1) }}>
        Upgrade for deeper insights
      </Heading>
      <Text>
        Move to a higher plan to unlock individual agent performance data and access other valuable features. Use these
        insights to refine support and provide targeted guidance.
      </Text>
    </PromoBannerV2>
  );
};
